import { gql } from '@apollo/client';

export const CREATE_VEHICLE = gql`
  mutation CreateVehicle($input: VehicleInput!) {
    createVehicle(input: $input)
  }
`;

export const UPDATE_VEHICLE = gql`
  mutation UpdateVehicle($input: VehicleInput!) {
    updateVehicle(input: $input)
  }
`;
